'use client';

import { useTranslations } from 'next-intl';
import { trackEvent } from '@/lib/analytics/matomo';
import WaitlistForm from '@/components/ui/WaitlistForm';

/**
 * Client-side hero CTA buttons that fire Matomo events.
 * Kept separate from the server-rendered page.tsx.
 */
export function HeroCTAs() {
  const t = useTranslations('landing.heroActions');

  return (
    <>
      <a
        href="#survey"
        className="inline-block px-8 py-3 bg-coral-500 hover:bg-coral-600 active:bg-coral-700 text-white font-heading font-semibold rounded-brand transition-colors"
        onClick={() => trackEvent('landing', 'hero_cta_click')}
      >
        {t('getEarlyAccess')}
      </a>
      <p className="mt-3">
        <a
          href="#waitlist-bottom"
          className="text-sm text-gray-500 hover:text-teal-500 transition-colors"
          onClick={() => trackEvent('landing', 'hero_waitlist_click')}
        >
          {t('orJoinWaitlist')}
        </a>
      </p>
    </>
  );
}

export function BottomWaitlist() {
  const t = useTranslations('landing.heroActions');

  return (
    <WaitlistForm
      layout="inline"
      className="max-w-sm mx-auto"
      socialProof={t('surveyPriority')}
    />
  );
}
